<template>
  <div>
    <template v-if="detalhes && detalhes.length > 0">
      <div class="table-outer-title font-weight-bold text-uppercase text-center">
        Detalhes — Equipamentos e Softwares
      </div>
      <div class="table-container">
        <table>
          <tr>
            <th>Tipo</th>
            <th>Descrição</th>
            <th>Tipo Apropriação</th>
            <th>Valor Depreciação</th>
            <th>Data Aquisição</th>
            <th>Valor</th>
          </tr>
          <tr v-for="(d, i) in detalhes" :key="i">
            <td>{{ d.tipo_rubrica }}</td>
            <td>{{ d.descricao }}</td>
            <td>{{ d.tipo_apropriacao }}</td>
            <td>{{ d.valor_depreciacao | toCurrency }}</td>
            <td>{{ d.data_aquisicao | toDate }}</td>
            <td>{{ d.valor | toCurrency }}</td>
          </tr>
          <tr class="font-weight-bold">
            <td colspan="5">Total</td>
            <td>{{ totalEquipamentos | toCurrency }}</td>
          </tr>
        </table>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "DetalhesEquipamentos",
  props: {
    detalhes: {
      type: Array,
      default: function () { return []; },
    },
  },
  computed: {
    totalEquipamentos() {
      return this.detalhes.reduce(function (sum, d) { return sum + (d.valor || 0); }, 0);
    },
  },
};
</script>

<style lang="scss" scoped src="../styles/report.scss"></style>
